import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { firstValueFrom } from "rxjs";

/** The server's JobOrderExplainService.ExplainResult. */
export interface JobOrderExplainResultDTO {
  /** Markdown. */
  Answer: string;
  ToolCalls: number;
  InputTokens: number;
  OutputTokens: number;
  CacheReadTokens: number;
  Seconds: number;
}

/** HTTP client for /api/JobOrderExplain. Read-only: the assistant explains, it never changes data. */
@Injectable({ providedIn: "root" })
export class JobOrderExplainApiService {
  private readonly baseUrl = environment.apiRoot + "api/JobOrderExplain";

  constructor(private http: HttpClient) {}

  async explain(joHeaderId: number, question: string | null): Promise<JobOrderExplainResultDTO> {
    return firstValueFrom(
      this.http.post<JobOrderExplainResultDTO>(`${this.baseUrl}/Explain`, { JoHeaderId: joHeaderId, Question: question }),
    );
  }
}
